import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  totalInfoWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    '& :first-child': {
      marginRight: 'unset',
    },
  },
  totalInfoContainer: {
    background: `${theme.palette.background.paper} 0% 0% no-repeat padding-box`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 4px 4px #00000005',
    borderRadius: '20px',
    padding: '30px 15px 30px 20px',
    maxWidth: 245,
    minWidth: 230,
    width: '100%',
    marginRight: '5px',
    [theme.breakpoints.down(1422)]: {
      maxWidth: 265,
      minWidth: 240,
      marginRight: 0,
    },
    '& p': {
      fontSize: '13px',
    },
    '& svg .a, .b': {
      fill: theme.palette.primary.main,
    },
    '& svg .a': {
      opacity: 0.2,
    },
  },
}));
